<template>
  <div class="loan-card">
    <div class="loan-success-tip">
      <van-swipe
        :autoplay="3000"
        :height="40"
        :show-indicators="false"
        vertical
      >
        <van-swipe-item v-for="item in loanSuccessTip" :key="item.id">{{
          item.name
        }}</van-swipe-item>
      </van-swipe>
    </div>
    <div class="content">
      <div class="title">最高可借额度(元)</div>
      <div class="amount">{{ amountFormatter(homeData.showQuotaAmount) }}</div>
      <div class="describe-list">
        <div v-for="item in describeList" :key="item.id" class="describe-item">
          <img :src="item.icon" alt="" />
          <span>{{ item.name }}</span>
        </div>
      </div>
      <div class="btn" @click="handApplyNow">
        <div class="btn-tip">快速审核</div>
        立即申请
      </div>
    </div>
    <Popup
      ref="popup2"
      :message="`当前剩余额度 ${homeData.remainCreditAmount}元，小于最小可借金额 ${homeData.minBorrowAmount}元，每期账单还清后，可增加最大授信额度`"
      confirmText="去提额"
      cancelText="取消"
      @confirm="handleUpgrade"
    />
    <Popup
      ref="popup3"
      :message="`${blackListAd?.popContent || '资质不匹配'}`"
      :confirmText="blackListAd?.popBtnName || '去查看'"
      cancelText="取消"
      :title="blackListAd?.popTitle || '资质不匹配'"
      @confirm="handleBlackListAd"
    />
    <Popup
      ref="popup4"
      :message="`${grayListAd?.popContent?.replace(
        '【greyDayNum】',
        preCheckData?.data?.greyDayNum || '',
      )}`"
      :confirmText="grayListAd?.popBtnName || '去查看'"
      cancelText="取消"
      :title="grayListAd?.popTitle || '资质审查中'"
      @confirm="handleGrayListAd"
    />
    <Popup
      ref="popup5"
      :message="`当前已存在${
        preCheckData?.data?.onWayOrderNum || 0
      }笔在途订单，订单还清后可重新借款`"
      confirmText="去还款"
      cancelText="取消"
      title="超出订单上线"
      @confirm="handleUpgrade"
    />
    <Popup
      ref="popup6"
      message="额度不够最小借贷金额"
      confirmText="去还款"
      cancelText="取消"
      title="额度不够"
      @confirm="handleUpgrade"
    />
  </div>
</template>

<script>
import { describeList, loanSuccessTip } from "@/utils/const";
import Popup from "@/components/Popup/index.vue";
import { infoErrorCode } from "@/utils/const";
import { preCheck, getHomeData, getUserAllInfo } from "@/api/index";
import { amountFormatter } from "@/utils/utils";
import { setLocalStorageData } from "@/common/index.js";
import { debounce } from "@/common/index";
export default {
  components: {
    Popup,
  },
  name: "LoanCard",
  data() {
    return {
      describeList,
      loanSuccessTip,
      show: true,
      infoErrorCode,
      MESSAGE: "请先进行实名认证",
      CONFIRM_TEXT: "去认证",
      CANCEL_TEXT: "取消",
      POPUPTITLE: "提示信息",
      amountFormatter,
    };
  },
  methods: {
    //去其他产品
    handleBlackListAd() {
      if (this.blackListAd.urlType == 1) {
        if (process.env.VUE_APP_ENV === "productionApp") {
          this.$JSBridge.send("serviceType", {
            type: "10",
            url: this.blackListAd.url,
            title: this.blackListAd.name,
          });
        } else {
          window.open(this.blackListAd.url);
        }
      }
    },
    handleGrayListAd() {
      if (this.grayListAd.urlType == 2) return;
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("serviceType", {
          type: "10",
          url: this.grayListAd.url,
          title: this.grayListAd.name,
        });
      } else {
        window.open(this.grayListAd.url);
      }
    },
    handleUpgrade() {
      this.$router.push({
        name: "orderList",
      });
    },
    handApplyNow: debounce(async function () {
      // 贷前检测
      const preCheckRes = await preCheck({});
      this.$store.commit("setPreCheckData", preCheckRes);
      setLocalStorageData("preCheckData", preCheckRes);
      const res = await getHomeData({});
      this.$store.commit("setHomeData", res.data);
      if (infoErrorCode.includes(preCheckRes.code)) {
        await this.getUserInfo();
        this.$toast("请先完成资质认证");
        this.$router.push({
          name: "idCardBinding",
        });
        return;
      } else if (preCheckRes.code == 10004 || preCheckRes.code == 10009) {
        this.$refs.popup3.showPopup();
        return;
      } else if (preCheckRes.code == 10005) {
        this.$refs.popup4.showPopup();
        return;
      } else if (preCheckRes.code == 10007) {
        this.$refs.popup2.showPopup();
        return;
      } else if (preCheckRes.code == 10008) {
        this.$refs.popup5.showPopup();
        return;
      } else if (
        this.homeData.remainCreditAmount < this.homeData.minBorrowAmount
      ) {
        this.$refs.popup2.showPopup();
        return;
      } else {
        this.$store.commit("setRouterFlag", "2");
        this.$router.push({
          name: "loan",
        });
      }
    }),
    
    //获取用户信息
    async getUserInfo() {
      const res = await getUserAllInfo();
      if (res.code === 2000) {
        setLocalStorageData("UserAllInfo", res.data);
      }
    },
  },
  computed: {
    homeData() {
      return this.$store.state.homeData;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    preCheckData() {
      return this.$store.state.preCheckData;
    },
    blackListAd() {
      return this.$store.state.blackListAd;
    },
    grayListAd() {
      return this.$store.state.grayListAd;
    },
  },
};
</script>

<style scoped lang="scss">
.loan-card {
  background-image: url("@/assets/style/loan-success-tip-bg.png");
  background-size: 100% 20%;
  background-repeat: no-repeat;
  border-radius: 16px;
}
.loan-success-tip {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  color: #fff;
  font-size: 14px;
  overflow: hidden;
}
.content {
  padding: 20px 23px;
  background: #fff;
  border-radius: 16px;
  margin-top: -12px;
  .title {
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    text-align: center;
    font-style: normal;
    padding-bottom: 12px;
  }
  .amount {
    font-weight: 600;
    font-size: 54px;
    color: #333333;
    text-align: center;
    font-style: normal;
  }
  .describe-list {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 16px;
    .describe-item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 13px;
      font-weight: 500;
      img {
        width: 40px;
        height: 40px;
        padding-bottom: 4px;
      }
    }
  }
  .btn {
    background: #1d70f7;
    border-radius: 50px;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #fff;
    text-align: center;
    font-style: normal;
    margin-top: 32px;
    position: relative;
    .btn-tip {
      position: absolute;
      right: 16px;
      top: -10px;
      height: 24px;
      width: 68px;
      background-image: url("@/assets/style/btn-tip-icon.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #fff;
      text-align: center;
      font-style: normal;
      line-height: 24px;
    }
  }
}
::v-deep(.van-swipe-item) {
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep(.van-swipe) {
  height: 52px;
}
</style>
